<template>
  <svg class='self' width='250' height='400'>
    <g class='face'>
      <path fill='none' stroke='#2D2D2D' stroke-width='2'
        d='
          M 55,120 C 70,40 180,40 195,120
          C 200,160 200,190 185,220
          C 155,270 90,270 65,220
          C 50,190 50,160 55,120
        '
      />
      <g class='eyes'>
        <ellipse fill='#2D2D2D'
          cx='90' cy='150' rx='5' ry='6'
        />
        <ellipse fill='#2D2D2D'
          cx='155' cy='150' rx='5' ry='6'
        />
        <path fill='none' stroke='#2D2D2D' stroke-width='2'
          d='M 98,155 Q 99,158 92,160'
        />
        <path fill='none' stroke='#2D2D2D' stroke-width='2'
          d='M 148,155 Q 147,158 155,160'
        />
      </g>
      <g class='nose'>
        <path fill='none' stroke='#2D2D2D' stroke-width='2'
          d='M 110,175 C 110,190 125,190 130,180'
        />
      </g>
      <g class='mouth'>
        <path fill='none' stroke='#2D2D2D' stroke-width='2'
          d='M 90,205 C 90,215 155,210 155,205'
        />
      </g>
    </g>
    <g class='body'>
      <path fill='none' stroke='#2D2D2D' stroke-width='2'
        d='M 85,244
          C 87,265 87,276 75,280
          C 85,310 164,310 170,280
          C 162,276 162,265 163,244'
      />
      <path fill='none' stroke='#2D2D2D' stroke-width='2'
        d='M 82,275 L 0,300 M 165,275 L 250,300'
      />
      <path class='stripe' fill='none' stroke='#2D2D2D' stroke-width='2'
        d='M 0,320
          L 250,320 250,340 0,340 0,320
          M 0,370
          L 250,370 250,390 0,390 0,370'
      />
    </g>
    <g class='hair'>
      <path fill='none' stroke='#2D2D2D' stroke-width='2'
        d='
            M 95,80 C 100,140 180,130 198,150
            C 196,185 200,215 163,244
            C 160,260 160,310 220,350
            C 220,355, 215,325 220,330
            C 230,350 260,360 265,370
            L 265,280
            C 255,300 210,240 220,150
            C 220,50 130,20 95,50
            C 60,40, 30,105 33,150
            C 33,220 5,280 -10,270
            L -30,350
            L 20,370
            C 5,330 80,300 85,245
            C 45,210 55,165 52,145
            L 95,80
        '
      />
    </g>
    <g class='ears'>
      <path fill='none' stroke='#2D2D2D' stroke-width='2'
        d='M 52,145 C 30,145 35,190 54,190 C 52,190 50,145 52,145'
      />
      <path fill='none' stroke='#2D2D2D' stroke-width='2'
        d='M 198,145 C 220,145 215,190 196,190 C 198,190 200,145 198,145'
      />
    </g>
    <g class='glasses'>
      <g class='lens'>
        <path fill='none' stroke='#2D2D2D' stroke-width='2'
              class='glass'
          d='
            M 165,130
            C 200,130 200,130 200,155
            C 200,155 200,180 165,180
            C 165,180 130,180 130,155
            C 130,130 130,130 165,130
          '
        />
        <path fill='none' stroke='#2D2D2D' stroke-width='2'
              class='glass'
          d='
            M 80,130
            C 115,130 115,130 115,155
            C 115,155 115,180 80,180
            C 85,180 45,180 45,155
            C 45,130 45,130 80,130
          '
        />
        <path fill='none' stroke='#2D2D2D' stroke-width='2'
          d='M 115,145 L 130,145'
        />
      </g>
      <g class='frame'>
        <path fill='none' stroke='#2D2D2D' stroke-width='2'
          d='
            M 129,145
            C 129,125 146,130 166,130
            L 203,130 203,133 200,133 200,143 197,143
            C 197,133 197,133 165,133
            C 135,133 135,133 132,145
            L 129,145
          '
        />
        <path fill='none' stroke='#2D2D2D' stroke-width='2'
          d='
            M 116,145
            C 116,125 99,130 79,130
            L 42,130 42,133 45,133 45,143 48,143
            C 48,133 48,133 79,133
            C 109,133 110,133 113,145
            L 115,145
          '
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'PortraitSvg',
}
</script>

<style scoped>
.self {
  border: 2px solid #2D2D2D;
}

.self .hair path {
  fill: #2D2D2D;
}

.self .frame path {
  fill: #888;
  stroke: #333;
}

.self .ears path {
  fill: #fff;
}

.self .lens path {
  stroke: #F2BF5C;
}

.self .stripe {
  fill: #F2BF5C;
  stroke:#F2BF5C;
}

.self .glass {
  fill: #4e3860;
  fill-opacity: 0;
  transition: fill-opacity 300ms ease;
}

.self:hover .glass {
  fill-opacity: 0.5;
  transition: fill-opacity 300ms ease;
}

@keyframes dim {
  0% {
    fill: #F2BF5C;
  }
  50% {
    fill: #F2BF5C;
  }
  100% {
    fill: #2D2D2D;
  }
}
</style>
